module.exports = __webpack_public_path__ + "img/top3.daf240bd.png";